import testImage from "@/assets/images/home/home-min.jpg"

export const BOOTCAMP_OVERVIEWS = [
  {
    title: "Aiming",
    id: "SwpmgRTy",
    placeholder: testImage,
    description:
      "Incredible Aim is at the core of any great Apex Legends player. In this Boot Camp, you'll learn from the best player in the game on how to perfect different aspects of your aim and stop having those frustrating missed shots.",
  },
  {
    title: "Movement",
    id: "lgR3iA92",
    placeholder: testImage,
    description:
      "Movement separates the greats from average players. Hal will teach you step by step not only how to perfect your flashy movement skills, but also when to use them during a fight.",
  },
  {
    title: "Decision-Making",
    id: "S3b1ICSg",
    placeholder: testImage,
    description:
      "Decision Making is one of the most underrated aspects in Apex Legends. With his many years of pro gaming, Hal will show you what it takes to compete at the highest level, and how to start making the right decision, every time.",
  },
]

export const BOOTCAMP_ENROLL_STEPS = {
  LANDING: "LANDING",
  REGISTER: "REGISTER",
  LOGIN: "LOGIN",
  PAYMENT: "PAYMENT",
  CONFIRM: "CONFIRM",
}



// WEBPACK FOOTER //
// ./src/constants/bootcamp.js